import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';
import { fetchMasksConfig, fetchedMasksConfig } from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';

type FetchActionPayload = ReturnType<typeof fetchMasksConfig>;

export function* getMasksConfigSaga({ meta: { callback } }: FetchActionPayload) {
  const { getMasksConfig } = getAPI();
  const response: YieldOf<typeof getMasksConfig> = yield call(getMasksConfig);
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedMasksConfig(data));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedMasksConfig(undefined, error));
  }

  if (callback) callback();
}

export default function* masksConfigSaga() {
  yield takeLatest(fetchMasksConfig.type, getMasksConfigSaga);
}
